import { render, staticRenderFns } from "./SaleXlsx.vue?vue&type=template&id=4a2a1434&"
import script from "./SaleXlsx.vue?vue&type=script&lang=js&"
export * from "./SaleXlsx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports